import { PostEditorReducerFunction, PostEditorToggleEvergreenAction } from '../PostEditorActions';
import { ImmutabilityContext } from '../effects/customImmutabilityContext';
import { EvergreenRecycleViewProps } from '../../Schedule/EvergreenRecycle/EvergreenRecycle.view';
import { ErrorMessageSeverity } from '../../../../constants/form';
import { OnStateUpdateCallbackFunction, postGroupStateUpdater } from '../../helpers/postGroupStateUpdater';
import { validatorStateUpdater } from '../../validators/helpers/validatorStateUpdater';

export const toggleEvergreenReducer: PostEditorReducerFunction<PostEditorToggleEvergreenAction['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { postGroupIndex, type, customizeIndex } = payload;
  const invertedType: EvergreenRecycleViewProps['type'] = type === 'evergreen' ? 'recurring' : 'evergreen';
  const callback: OnStateUpdateCallbackFunction = currentPost =>
    updateImmutable(currentPost, {
      scheduling: {
        [type]: {
          active: {
            $apply: (current: boolean) => !current
          }
        },
        [invertedType]: {
          active: { $set: false }
        }
      }
    });
  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'schedule', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, [
    'checkExpiryCount',
    'checkExpiryDate',
    'expireDateRequired',
    'expireCountRequired',
    'profileRequired',
    'scheduleTextOrMediaVariations'
  ]);
};
